import { useTranslation } from 'react-i18next';

import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import Button from '@appchoose/button';

interface BrandValidationDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
}

function BrandValidationDialog({
  open,
  onOpenChange,
  onConfirm,
}: BrandValidationDialogProps) {
  const { t } = useTranslation();

  const handleCancel = () => {
    onOpenChange(false);
  };

  const handleConfirm = () => {
    onOpenChange(false);
    onConfirm();
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="text-center text-lg font-semibold">
            {t('page.validation_modal_title')}
          </DialogTitle>
        </DialogHeader>

        <p className="py-4 text-sm text-muted-foreground">
          {t('page.validation_modal_message')}
        </p>

        <DialogFooter className="flex gap-3">
          <Button
            type="button"
            appearance="outline"
            onClick={handleCancel}
            className="flex items-center gap-2"
          >
            {t('general.cancel')}
          </Button>
          <Button
            type="button"
            appearance="primary"
            onClick={handleConfirm}
            className="flex items-center gap-2"
          >
            {t('page.validation_button')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

export default BrandValidationDialog;
